import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { createAction, props } from '@ngrx/store';
import { OrderedSet } from 'immutable';

export enum TagAction {
	SetAvailableTags = '[BE] set available tags',
}

export const setGloballyAvailableTags = createAction(
	TagAction.SetAvailableTags,
	props<{ availableTags: OrderedSet<AppTagItemEntity> }>()
);
